import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const Table = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_table_lazy" */
    "./table.js"
  )
);
const TableRow = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_tableRow_lazy" */
    "./table-row.js"
  )
);
const TableCell = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_tableCell_lazy" */
    "./table-cell.js"
  )
);
const TableRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Table, { key: node.id, node, ...props });
};
const TableLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(TableRenderer, { key: node.id, node, ...props }));
};
const TableRowRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(TableRow, { key: node.id, node, ...props });
};
const TableRowLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(TableRowRenderer, { key: node.id, node, ...props }));
};
const TableCellRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(TableCell, { key: node.id, node, ...props });
};
const TableCellLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(TableCellRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.TABLE]: TableLazy,
  [Node_Type.TABLE_ROW]: TableRowLazy,
  [Node_Type.TABLE_CELL]: TableCellLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
